import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { RootStoreContext } from '../stores/RootStore';

const EventNotFound = () => {
  const navigate = useNavigate();
  const { registrationStore, authStore } = useContext(RootStoreContext);

  const handleBackToCheckin = () => {
    if (authStore.isUserFlow) {
      registrationStore.clearSelectedItems();
      registrationStore.toSellingItems();
    } else {
      registrationStore.restart();
    }
    navigate('/');
  };

  return (
    <Container className="text-center">
      <Row>
        <Col className="text-center">
          <FontAwesomeIcon icon={faExclamationTriangle} size="5x" color="gray" />
          <h2 className="mt-4">Event not found</h2>
          <p className="text-muted">
            This event is unavailable or is no longer offered in the Check-in App.
          </p>
          <Button variant="info" onClick={handleBackToCheckin}>
            Back to Check-in
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default EventNotFound;
